import React from "react";
import { Link, useMatch, useResolvedPath } from "react-router-dom";
import "../styles/styles.css";
import "../../../styles/global.css";

const CustomLink = ({ onLinkClick, to, children, src, ...props }) => {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });

  return (
    <Link
      onClick={onLinkClick}
      to={`../${to}`}
      {...props}
      className={`flex-directions-row items-center navbar-link ${
        isActive ? "active" : ""
      }`}
    >
      <img src={src} width={24} height={24} alt="icon" />
      <p className="inria-sans-300 font-14 weight-700 navbar-term">
        {children}
      </p>
    </Link>
  );
};

export default CustomLink;
